import { Tooltip, Dialog } from "radix-ui";

import { useBreakLG } from "../../utils/breakpointHooks";
import { Close, Info } from "@monta/icons";

import type { Props } from "./types";

const RadixTooltip = ({
  trigger = <Info size={20} />,
  children,
  delayDuration = 200,
  skipDelayDuration = 500,
  triggerClassName = "",
  contentClassName = "",
  defaultOpen = false
}: Readonly<Props>) => {
  const isDesktop = useBreakLG();

  if (!isDesktop) {
    return (
      <Dialog.Root defaultOpen={defaultOpen}>
        <Dialog.Trigger asChild>
          <button className={`focus:outline-none ${triggerClassName}`}>
            {trigger}
          </button>
        </Dialog.Trigger>

        <Dialog.Portal>
          <Dialog.Overlay className="fixed inset-0 bg-black/50 z-[9999]" />

          <Dialog.Content className="fixed bottom-0 rounded-tr-5 rounded-tl-5 bg-white p-6 !pt-8 shadow-lg w-full z-[10000]">
            <Dialog.Close asChild>
              <button className="absolute top-8 left-4 w-5 h-5">
                <Close size={20} />
              </button>
            </Dialog.Close>
            {children}
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    );
  }

  return (
    <Tooltip.Provider
      delayDuration={delayDuration}
      skipDelayDuration={skipDelayDuration}
    >
      <Tooltip.Root defaultOpen={defaultOpen}>
        <Tooltip.Trigger asChild>
          <button className={`focus:outline-none ${triggerClassName}`}>
            {trigger}
          </button>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            className={`w-full ${contentClassName}`}
            side="left"
            align="center"
          >
            {children}
            <Tooltip.Arrow
              className="fill-white !top-0"
              width={24}
              height={16}
              style={{
                borderRadius: "4px"
              }}
            />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export default RadixTooltip;
